<div class="row forgot-password-page">
  <div class="col-xl-4 col-lg-5 col-md-6 col-sm-6 ml-auto mr-auto login-col">
    <section class="login-box">
      <div class="row">
        <div class="col align-self-center">
          <div class="card login-card">
            <div class="card-title">
              <div class="col lang-box" *ngIf="false">
                <select class="custom-select" id="gender2" style="float: right">
                  <option selected value="it">IT</option>
                  <option value="en">EN</option>
                </select>
              </div>
            </div>
            <div class="card-body">
              <div *ngIf="ecobonusFlag">
                <div class="col welcome-box mt-4 lead text-center">
                  Piattaforma
                </div>
                <div class="col image-box mt-2">
                  <img class="image-login" [src]="baseHref + '/assets/images/login-ecobonus.png'"/>
                </div>
                <div class="col image-box mt-2">
                  <img class="image-login" [src]="baseHref + '/assets/images/logo-login.png'"/>
                </div>
              </div>
              <div *ngIf="bandiIncentiviFlag">
                <div class="col welcome-box mt-4 lead text-center">
                  Piattaforma
                </div>
                <div class="col image-box mt-2">
                  <img class="image-login" [src]="baseHref + '/assets/images/logo-bandi-e-incentivi.png'"/>
                </div>
                <div class="col image-box mt-2">
                  <img class="image-login" [src]="baseHref + '/assets/images/logo-login.png'"/>
                </div>
              </div>
              <div *ngIf="!ecobonusFlag && !bandiIncentiviFlag" class="col image-box mt-2">
                <!-- <img class="image-login" [src]="baseHref + '/assets/images/digital-suite-tls.png'"/> -->
                <span class="title">Legal Digital Suite</span>
              </div>
              <div class="col welcome-box">
                <h3>Recupera password</h3>
                <span>Inserisci il tuo indirizzo email</span>
                <hr>
              </div>
              <div class="col form-box">
                <form [formGroup]="loginForm" (ngSubmit)="onSubmit()">
                  <div class="form-group" *ngIf="!showSuccess">
                    <label for="email">Email</label>
                    <input type="text" maxlength="255" formControlName="email" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.email.errors }" />
                    <div *ngIf="submitted && f.email.errors" class="invalid-feedback">
                      <div *ngIf="f.email.errors.required">Email obbligatoria</div>
                      <div *ngIf="f.email.errors.email">La mail non ha un formato valido</div>
                      <!-- <div *ngIf="f.email.errors.required">Email required</div>
                      <div *ngIf="f.email.errors.email">Email not recognized</div> -->
                    </div>
                  </div>
                  <div class="form-group" *ngIf="!showSuccess">
                    <br>
                    <button [disabled]="loading" class="btn btn-primary custom-align">Invia</button>
                    <img *ngIf="loading" class="pl-2" src="data:image/gif;base64,R0lGODlhEAAQAPIAAP///wAAAMLCwkJCQgAAAGJiYoKCgpKSkiH/C05FVFNDQVBFMi4wAwEAAAAh/hpDcmVhdGVkIHdpdGggYWpheGxvYWQuaW5mbwAh+QQJCgAAACwAAAAAEAAQAAADMwi63P4wyklrE2MIOggZnAdOmGYJRbExwroUmcG2LmDEwnHQLVsYOd2mBzkYDAdKa+dIAAAh+QQJCgAAACwAAAAAEAAQAAADNAi63P5OjCEgG4QMu7DmikRxQlFUYDEZIGBMRVsaqHwctXXf7WEYB4Ag1xjihkMZsiUkKhIAIfkECQoAAAAsAAAAABAAEAAAAzYIujIjK8pByJDMlFYvBoVjHA70GU7xSUJhmKtwHPAKzLO9HMaoKwJZ7Rf8AYPDDzKpZBqfvwQAIfkECQoAAAAsAAAAABAAEAAAAzMIumIlK8oyhpHsnFZfhYumCYUhDAQxRIdhHBGqRoKw0R8DYlJd8z0fMDgsGo/IpHI5TAAAIfkECQoAAAAsAAAAABAAEAAAAzIIunInK0rnZBTwGPNMgQwmdsNgXGJUlIWEuR5oWUIpz8pAEAMe6TwfwyYsGo/IpFKSAAAh+QQJCgAAACwAAAAAEAAQAAADMwi6IMKQORfjdOe82p4wGccc4CEuQradylesojEMBgsUc2G7sDX3lQGBMLAJibufbSlKAAAh+QQJCgAAACwAAAAAEAAQAAADMgi63P7wCRHZnFVdmgHu2nFwlWCI3WGc3TSWhUFGxTAUkGCbtgENBMJAEJsxgMLWzpEAACH5BAkKAAAALAAAAAAQABAAAAMyCLrc/jDKSatlQtScKdceCAjDII7HcQ4EMTCpyrCuUBjCYRgHVtqlAiB1YhiCnlsRkAAAOwAAAAAAAAAAAA==" />
                  </div>
                  <div *ngIf="error" class="alert alert-danger">{{error}}</div>
                  <div *ngIf="showSuccess" class="text-center">L'email di recupero password è stata inviata</div>
                </form>
              </div>
              <div class="col welcome-box" *ngIf="!ecobonusFlag">
                <hr>
                <span>Torna alla pagina di <a href="javascript:;" (click)="goToLoginPage()">Login</a></span>
              </div>
              <div class="col welcome-box" *ngIf="ecobonusFlag">
                <hr>
                <span>Torna alla pagina di <a [href]="environment.meUrl">Login</a></span>
              </div>
              <div class="col welcome-box" *ngIf="ecobonusFlag">
                <br>
                <img alt="PwC TLS Avvocati e commercialisti" class="logo-footer ml-auto" src="/assets/images/logo_footer_v2.PNG">
              </div>
              <div class="col welcome-box">
                <br>
                <img alt="PwC TLS Avvocati e commercialisti" class="logo-footer ml-auto" src="/assets/images/logo_footer_v2.PNG">
              </div>
            </div>
          </div>
        </div>
      </div>

    </section>
  </div>
</div>
